'use client';
import { ComponentType } from 'react';
import { HeightSinceWidth } from '../placeholder/placeholder.component';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './order-list.component';
import dynamic from 'next/dynamic';

const DynamicOrderListComponent: ComponentType<Props> = dynamic(
  () => import('./order-list.component')
);

export default DynamicOrderListComponent;

export function calculateOrderListPlaceholderConfig(props: Props): PlaceholderConfig {
  const ordersCount: number = props.orders.length;
  let heightSinceWidth: HeightSinceWidth;

  if (ordersCount !== 0) {
    heightSinceWidth = [
      { sinceWidth: 0, height: ordersCount * 120 + 60 },
      { sinceWidth: 420, height: ordersCount * 120 + 60 },
      { sinceWidth: 480, height: ordersCount * 120 + 60 },
      { sinceWidth: 768, height: ordersCount * 150 + 60 },
      { sinceWidth: 1024, height: (ordersCount / 2) * 135 + 60 },
      { sinceWidth: 1440, height: (ordersCount / 2) * 135 + 60 }
    ];
  } else {
    heightSinceWidth = [
      { sinceWidth: 0, height: 250 },
      { sinceWidth: 325, height: 256 },
      { sinceWidth: 425, height: 296 },
      { sinceWidth: 525, height: 336 },
      { sinceWidth: 625, height: 376 },
      { sinceWidth: 768, height: 324 },
      { sinceWidth: 1024, height: 384 },
      { sinceWidth: 1442, height: 481 }
    ];
  }

  return {
    heightSinceWidth
  };
}
